export default __webpack_public_path__ + "static/garden_design28-5b3d5dc781664b5b14f6660f5174efda.webp";